import React from 'react';

const OpenPlayPage = () => {
  return <div>OpenPlayPage 임시 페이지 입니다.</div>;
};

export default OpenPlayPage;
